<template>
  <div class='content'>
    <div class='base'>
      <div :class="$taskType === 'CONNECT_LINES_ANSWER' ? 'left' : 'left-base'">
        <PositionDropdown class="field" @setItem="setFolder" />
        <NumericInput
          class="field"
          :value="+$score"
          label="Баллы"
          placeholder="Введите количество баллов"
          @input="setScore"
        />
        <TaskTypesDropdown class="field" @setItem="setTaskType" />
        <component
          v-if="$taskType"
          :is="taskComponent"
        />
        <LanguagesDropdown
          class="field"
          :value="$language"
          @click="setLanguage"
        />
      </div>
      <div class='right'>
        <p class="text"> Количество</p>
        <div :class="baseRightStyle">
          <NumericInput :value="+$count" @input="setCount" />
          <BaseButton
            class="btn"
            big
            @click="duplicateAssignment"
          >
            Дублировать
          </BaseButton>
        </div>
        <BaseSwitch
          v-if="![ 'new', 'archive' ].includes($status)"
          class="switch field"
          :checked="$isArchive"
          @change="setIsArchive"
        >
          <p>Архив</p>
        </BaseSwitch>
        <BaseSwitch
          v-if="[ 'reserve', 'archive' ].includes($status)"
          class="switch field"
          :checked="$isPublished"
          @change="setIsPublished"
        >
          <p>Опубликовано</p>
        </BaseSwitch>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import PositionDropdown from '@/pages/common/dropdowns/bank/lesson-tasks/position-dropdown/PositionDropdown.vue'
import TaskTypesDropdown from '@/pages/common/dropdowns/bank/task-types-dropdown/TaskTypesDropdown.vue'
import LanguagesDropdown from '@/pages/bank/lesson-tasks/edit/parts/languages-dropdown/LanguagesDropdown.vue'
import NumericInput from '@/ui/input/NumericInput.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import BaseSwitch from '@/ui/switch/BaseSwitch.vue'
import FormInput from '@/ui/input/FormInput.vue'
import {
  setFolder,
  setScore,
  $score,
  $taskType,
  setTaskType,
  $language,
  setLanguage,
  $count,
  setCount,
  duplicateAssignment,
} from '@/pages/bank/lesson-tasks/edit/task-edition-page.model'
import * as tasks from '@/pages/common/parts/tasks/'
import { mapTaskTypeTo } from '@/pages/common/constants'
import {
  $isArchive,
  $isPublished,
  $status,
  setIsArchive,
  setIsPublished,
} from '@/pages/common/parts/status-controller/status.model'
import { resetCounters } from '@/pages/common/parts/tasks/moving-images-on-image-input-answer/form/moving-images-on-image-answer-form.model'
import { resetCounters as resetImagesOnTextCounters } from '@/pages/common/parts/tasks/moving-images-on-text-input-answer/form/moving-images-on-text-input-answer-form.model'

export default Vue.extend({
  name: 'TaskContent',
  components: {
    PositionDropdown,
    TaskTypesDropdown,
    LanguagesDropdown,
    NumericInput,
    BaseButton,
    BaseSwitch,
    FormInput,
  },
  effector: {
    $score,
    $taskType,
    $language,
    $count,
    $status,
    $isArchive,
    $isPublished,
  },
  data() {
    return {
      display: false,
    }
  },
  computed: {
    taskComponent() {
      return this.$taskType ? tasks[mapTaskTypeTo[this.$taskType].componentName] : null
    },
    baseRightStyle() {
      return this.$taskType === 'CONNECT_LINES_ANSWER' && !this.display ? 'wrapper' : 'wrapper-base'
    },
  },
  watch: {
    taskComponent: {
      handler(newVal, oldVal) {
        if (oldVal) {
          resetCounters()
          resetImagesOnTextCounters()
        }
      },
    },
  },
  methods: {
    setFolder,
    setScore,
    setTaskType,
    setLanguage,
    setCount,
    duplicateAssignment,
    setIsArchive,
    setIsPublished,
    onResize() {
      this.display = window.innerWidth > 1600
    },
  },
  created() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
})
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  padding: 30px;
  background-color: #fff;
  border-radius: 3px;
}
.base {
  display: flex;
  justify-content: space-between;
}
.left,
.right {
  display: flex;
  flex-direction: column;
}
.left-base {
  flex-basis: 60%;
}
.left {
  @mixin bank-base-left;
}
.right {
  @mixin bank-base-right-wrapper;
}
.tasks-count {
  display: flex;
  align-items: center;
}
.field {
  margin-bottom: 20px;
}
.field.numeric {
  width: 100%;
  & ::v-deep input {
    width: 100%;
  }
  & ::v-deep span {
    display: none;
  }
}
.text {
  font-weight: 600;
}
@media screen and (max-width: 1825px) {
  .left {
    flex-basis: 65%;
  }
}
@media screen and (max-width: 1600px) {
  .right {
    flex-basis: 0;
  }
}
</style>
